import Vue from 'vue'
import dialog from '@/components/common/dialog/index.js'

Object.defineProperty(Vue.prototype, '$dialog', { value: dialog })